export default __webpack_public_path__ + "static/media/py.f30bb5ab.svg";